import { Button, Img, Heading, Text } from "./..";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import ImagesCarousel from "components/ImagesCarousel";
import { formatPrice } from "utils/formatPrice";

const DEFAULT_IMG = { image_url: "/images/img_car11_qgcqjcnfp_428x738.png", __isDefault: true };

const statusMap = {
//  0: { txt: "ממתין להצעה", clr: "#808080cc" },
    0: { txt: "ממתין להצעה", clr: "#CE0000"  },
  1: { txt: "ממתין לאישור", clr: "#CE0000" },
  2: { txt: "מאושר", clr: "#619D1C" },
  3: { txt: "הצעה שנדחתה", clr: "#666666" },
  4: { txt: "ארכיון", clr: "#666666" },
  5: { txt: "לא מעונין", clr: "#666666" }, // NEW
};


export default function CarCardTemplate({
  id,
  year,
  manufacturer,
  model,
  hand,
  gearbox,
  engine_type,
  images = [],
  offer_status,
  offered_price,
  approved_other,
  ...props
}) {
  const imagesSafe = useMemo(() => {
    const has = Array.isArray(images) && images.length > 0;
    return has ? images : [DEFAULT_IMG];
  }, [images]);

  const formatOfferText = (text) => {
    if (text === null || text === undefined || text === "") return "";
    const s = String(text).trim();
    if (s.includes("-")) {
      return s
        .split("-")
        .map((v) => formatPrice(String(v).trim()))
        .join(" - ");
    }
    return formatPrice(s);
  };

  const displayStatus =
    Number(offer_status) === 0 && Number(approved_other) === 1 ? 4 : Number(offer_status);

  const offerText = props.offer_range ?? offered_price ?? "";
  const hasOfferText = offerText !== null && offerText !== undefined && String(offerText).trim() !== "";
  const { txt, clr } = statusMap[displayStatus] ?? statusMap[0];

  const navigate = useNavigate();
  const navigateCarProfil = () => navigate(`${id}`);

  return (
    <div {...props} className={`${props.className} relative flex flex-col w-full rounded-[16px] overflow-hidden border border-solid border-gray-200 bg-secondary-primary_white`}>
      {/* Container לתמונה עם גובה קבוע */}
      <div className="relative w-full h-[220px] sm:h-[250px] overflow-hidden">
        <Button
          shape="round"
          className="ml-[15px] mt-[17px] rounded-[14px] font-medium capitalize text-white font-[DM Sans]"
          style={{
            zIndex: "999",
            backgroundColor: clr,
            color: "white",
            padding: "8px 20px",
            position: "absolute",
            top: 0,
            right: 0
          }}
        >
          {txt}
        </Button>

        {hasOfferText && (
          <div className="absolute w-full bottom-0 flex justify-center py-1" style={{ backgroundColor: clr, opacity: 0.8, zIndex: 999 }}>
            <Heading size="headingxl" className="!font-heebo text-[14px] font-bold !text-secondary-primary_white">
              {String(offerText).includes("-")
                ? `טווח הצעות: ₪${formatOfferText(offerText).replace(" - ", " - ₪")}`
                : `מחיר ההצעה: ₪${formatOfferText(offerText)}`}
            </Heading>
          </div>
        )}

        {/* עטיפה לקרוסלה כדי לוודא גובה אחיד */}
        <div className="w-full h-full">
            <ImagesCarousel images={imagesSafe} className="h-full w-full object-cover" />
        </div>
      </div>

      {/* חלק המידע - גובה קבוע או גמיש אך אחיד */}
      <div className="flex flex-col gap-6 p-5 flex-grow">
        <div className="flex flex-col items-center gap-3">
          <div className="flex flex-col items-center gap-1">
            <Heading as="h6" className="!font-heebo text-[18px] font-bold !text-black-900 text-center">
              {model}
            </Heading>
            <div className="flex items-center justify-center gap-2">
              <Text as="p" className="text-[14px] font-normal">{year}</Text>
              <div className="h-[5px] w-[5px] rounded-full bg-red-600" />
              <Text as="p" className="text-[14px] font-normal">{manufacturer}</Text>
            </div>
          </div>

<div className="grid grid-cols-3 w-full  pt-4">
  <div className="flex flex-col items-center gap-1 px-1 min-w-0">
    <Img src="/images/img_icon_black_900_01.svg" alt="מנוע" className="h-[18px] shrink-0" />
    <Text as="p" className="text-[13px] font-normal text-center truncate w-full">
      {engine_type}
    </Text>
  </div>

  <div className="flex flex-col items-center gap-1 px-1 min-w-0 border-x border-gray-100">
    <Img src="/images/img_artboard_2_copy_3_black_900_03_3.svg" alt="יד" className="h-[18px] shrink-0" />
    <Text as="p" className="text-[13px] font-normal text-center truncate w-full">
      יד {hand}
    </Text>
  </div>

  <div className="flex flex-col items-center gap-1 px-1 min-w-0">
    <Img src="/images/img_icon_black_900.svg" alt="גיר" className="h-[18px] shrink-0" />
    <Text as="p" className="text-[13px] font-normal text-center truncate w-full">
      {gearbox}
    </Text>
  </div>
</div>

        </div>
      </div>
    </div>
  );
}